
import { StoreApi } from 'zustand';
import { PriceState } from '../../types';
import { UserState } from '../../../auth/userSlice';
import { priceAlertService } from '@/services/priceAlerts/priceAlertService';

type GetPriceState = () => PriceState & UserState;
type SetPriceState = StoreApi<PriceState & UserState>["setState"];

export const loadUserPriceAlerts = async (
  set: SetPriceState,
  get: GetPriceState,
  userId: string
) => {
  try {
    console.log('[loadUserPriceAlerts] Loading alerts for user:', userId);
    
    const alerts = await priceAlertService.loadUserAlerts(userId);
    
    console.log('[loadUserPriceAlerts] Loaded alerts:', alerts.length);
    
    set((state: PriceState & UserState) => ({
      priceAlerts: [...state.priceAlerts.filter(alert => !alert.userId), ...alerts]
    }));
  } catch (error) {
    console.error('[loadUserPriceAlerts] Error loading user alerts:', error);
  }
};
